// Text and background colours of the rich text editors (articles, events):
//first row - Platforma brand colours, then the standard editor palette
export const EDITOR_PALETTE = [
  "#00a3b7", "#00838f", "#59b6b9", "#e6f6f8", "#3c3c3b", "#575756", "#d9e4eb",
  "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
  "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
  "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
  "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
  "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466",
];
